import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgModule } from "@angular/core";
import { CommonModule, NgOptimizedImage } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FooterComponent } from "src/app/Module/Navigation/footer/footer.component";
import { TopMenuComponent } from "src/app/Module/Navigation/top-menu/top-menu.component";
import { SideMenuComponent } from "src/app/Module/Navigation/side-menu/side-menu.component";
import { getInTouchComponent } from "../../Module/Navigation/get-in-touch/get-in-touch.component";
import { ConfirmDialogComponent } from "./confirm-dialog/confirm-dialog.component";

import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ModalModule } from "ngx-bootstrap/modal";
import { SuccessDialogComponent } from "./success-dialog/success-dialog.component";
import { ErrorDialogComponent } from "./error-dialog/error-dialog.component";
import { admin_headerComponent } from "src/app/Module/Navigation/header/admin-header/admin-header.component";
import { AdminHeaderComponent } from "src/app/Module/Navigation/header/auth-header/auth-header.component";
import { CreateAdminComponent } from "./create-admin/create-admin.component";
import { ResetPasswordComponent } from "./reset-password/reset-password.component";
import { CaptchaComponent } from "./captcha/captcha.component";
import { UpdateRoleComponent } from "./update-role/update-role.component";
import { NgSelectModule } from "@ng-select/ng-select";
import { HttpClientModule } from "@angular/common/http";
import { UserHeaderComponent } from "src/app/Module/Navigation/header/user-header/userheader.component";
import { BatchUploadComponent } from "./batch-upload/batch-upload.component";
import { FileSizePipe } from "../filesize.pipe";
import { NairaCurrencyPipe } from "./nairaCurrency";
import { CreateSelfAssessmentComponent } from "../../Module/Users/assessments/create-self-assessment/create-self-assessment.component";
import { QueryModalComponent } from "./query-modal/query-modal.component";
import { TemaQueryCommentsModalComponent } from "./tema-query-comments-modal/tema-query-comments-modal.component";
import { PaymentMethodModalComponent } from "./payment-method-modal/payment-method-modal.component";
import { DaDemandNoticeComponent } from "./notices/da-demand-notice/da-demand-notice.component";
import { RemoveUnderscoresPipe } from "./remove-underscores.pipe";
import { SeparatorDirective } from "./separator/separator.directive";
import { NumberToWordsPipe } from "./number-to-words.pipe";
import { NonTaxDemandNoticeComponent } from "./notices/non-tax-demand-notice/non-tax-demand-notice.component";
import { ChartTestComponent } from "./notices/chart-test/chart-test.component";
import { AmountPipe } from "./pipes/amount.pipe";
import { DateonlyPipe } from "./pipes/dateonly.pipe";
import { DatetimePipe } from "./pipes/datetime.pipe";
import { ShortestDatePipe } from "./pipes/shortest-date.pipe";
import { YearOnlyPipe } from "./pipes/year-only.pipe";
import { ErrorMessageComponent } from "./error-message/error-message.component";
import { ImageCropperModule } from "ngx-image-cropper";
import { AppLoaderComponent } from "./app-loader/app-loader.component";
import { FileUploadComponent } from "./file-upload/file-upload.component";
import { ImageCropperComponent } from "./image-cropper/image-cropper.component";
import { NgxDropzoneModule } from "ngx-dropzone";
import { WarningDialogComponent } from "./warning-dialog/warning-dialog.component";
import { PageSizeComponent } from "./page-size/page-size.component";
import { MillionFormatterPipe } from "../million-formatter.pipe";
import { CameraTestingComponent } from "./camera-testing/camera-testing.component";
import { NumberFormatDirective } from "./number-format/number-format.directive";
import { UserCommentGlobalComponent } from "./user-comment-global/user-comment-global.component";
import { AngularEditorModule } from "@kolkov/angular-editor";
import { MdaHeaderComponent } from "../../Module/Navigation/header/mda-header/mda-header.component";
import { MdaFooterComponent } from "../../Module/Navigation/header/mda-footer/mda-footer.component";
import { UserManagementInformalComponent } from "../../Module/Admin/user-management-informal/user-management-informal.component";
import { AdminUserProfileComponent } from "../../Module/Admin/admin-user-profile/admin-user-profile.component";
import { CropProfilePictureComponent } from "../../Module/Admin/crop-profile-picture/crop-profile-picture.component";
import { AuditTrailsComponent } from "../../Module/Admin/audit/audit-trails/audit-trails.component";
import { VerificationComponent } from "../../Module/Admin/verifications/verification/verification.component";
import { PaymentReconciliationComponent } from "../../Module/Admin/reconciliations/payment-reconciliation/payment-reconciliation.component";
import { PaymentCheckStatusComponent } from "../../Module/Admin/reconciliations/payment-check-status/payment-check-status.component";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { RemoveUnderscoreAndSpacePipe } from "../custom-pipe/remove-underscore-and-space/remove-underscore-and-space.pipe";
import { SignedPercentagePipe } from "../custom-pipe/signed-percentage-pipe/signed-percentage.pipe";
import { ErrorModalComponent } from "../modals/error-modal/error-modal.component";
import { AutoDataLabelDirective } from "../directives/auto-data-label/auto-data-label.directive";
import { BounceLoaderComponent } from "../components/bounce-loader/bounce-loader.component";
import { SingleInvoiceActionsDropdownComponent } from "../components/single-invoice-actions-dropdown/single-invoice-actions-dropdown.component";
import { LottieComponent } from "ngx-lottie";
import { OnlyNumberDirective } from "../directives/number-only/only-number.directive";
import { TaxpayerRecordUpdateNotificationComponent } from "./taxpayer-record-update-notification/taxpayer-record-update-notification.component";

import { MatStepperModule } from "@angular/material/stepper";
import { NairaAbbreviatePipe } from "./pipes/naira-abrev/naira-abbreviate.pipe";
import { DataIntegrationWrapperComponent } from "../components/data-items/data-integration-wrapper/data-integration-wrapper.component";
import { AnsaaDataIntegrationComponent } from "../components/data-items/ansaa-data-integration/ansaa-data-integration.component";
import { IvasDataIntegrationComponent } from "../components/data-items/ivas-data-integration/ivas-data-integration.component";
import { TransportDataIntegrationComponent } from "../components/data-items/transport-data-integration/transport-data-integration.component";
import { HaulagetDataIntegrationComponent } from "../components/data-items/haulage-data-integration/haulage-data-integration.component";
import { MotDataIntegrationComponent } from "../components/data-items/mot-data-integration/mot-data-integration.component";
import { ArtmaDataIntegrationComponent } from "../components/data-items/artma-data-integration/artma-data-integration.component";
import { AnsppbDataIntegrationComponent } from "../components/data-items/ansppb-data-integration/ansppb-data-integration.component";
import { CultureDataIntegrationComponent } from "../components/data-items/culture-data-integration/culture-data-integration.component";
import { DashboardSummaryCardsComponent } from "./dashboard-summary-cards/dashboard-summary-cards.component";
import { IconifyComponent } from "../standalone-components/iconify/iconify.component";
import { SafeUrlPipePipe } from "../custom-pipe/safe-url-pipe.pipe";
import { SessionDialogComponent } from "./session-dialog/session-dialog.component";

@NgModule({
  declarations: [
    FooterComponent,
    TopMenuComponent,
    SideMenuComponent,
    ConfirmDialogComponent,
    SuccessDialogComponent,
    ErrorDialogComponent,
    admin_headerComponent,
    AdminHeaderComponent,
    CaptchaComponent,
    CreateAdminComponent,
    ResetPasswordComponent,
    UpdateRoleComponent,
    UserHeaderComponent,
    BatchUploadComponent,
    FileSizePipe,
    NairaCurrencyPipe,
    CreateSelfAssessmentComponent,
    QueryModalComponent,
    TemaQueryCommentsModalComponent,
    PaymentMethodModalComponent,
    DaDemandNoticeComponent,
    RemoveUnderscoresPipe,
    NonTaxDemandNoticeComponent,
    ChartTestComponent,
    SeparatorDirective,
    NumberToWordsPipe,
    NonTaxDemandNoticeComponent,
    AmountPipe,
    DateonlyPipe,
    DatetimePipe,
    ShortestDatePipe,
    YearOnlyPipe,
    ErrorMessageComponent,
    AppLoaderComponent,
    FileUploadComponent,
    ImageCropperComponent,
    WarningDialogComponent,
    PageSizeComponent,
    MillionFormatterPipe,
    CameraTestingComponent,
    NumberFormatDirective,
    UserCommentGlobalComponent,
    MdaFooterComponent,
    MdaHeaderComponent,
    UserManagementInformalComponent,
    AdminUserProfileComponent,
    CropProfilePictureComponent,
    AuditTrailsComponent,
    VerificationComponent,
    PaymentReconciliationComponent,
    PaymentCheckStatusComponent,
    DateonlyPipe,
    SafeUrlPipePipe,
    NairaCurrencyPipe,
    RemoveUnderscoresPipe,
    RemoveUnderscoreAndSpacePipe,
    SignedPercentagePipe,
    ErrorModalComponent,
    AutoDataLabelDirective,
    OnlyNumberDirective,
    BounceLoaderComponent,
    SingleInvoiceActionsDropdownComponent,
    NairaAbbreviatePipe,
    SignedPercentagePipe,
    DataIntegrationWrapperComponent,
    AnsaaDataIntegrationComponent,
    IvasDataIntegrationComponent,
    TransportDataIntegrationComponent,
    HaulagetDataIntegrationComponent,
    MotDataIntegrationComponent,
    ArtmaDataIntegrationComponent,
    AnsppbDataIntegrationComponent,
    CultureDataIntegrationComponent,
    DashboardSummaryCardsComponent,
    SessionDialogComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgOptimizedImage,
    NgbModule,
    NgSelectModule,
    ModalModule.forRoot(),
    ImageCropperModule,
    NgxDropzoneModule,
    BsDatepickerModule,
    AngularEditorModule,
    LottieComponent,
    MatStepperModule,
    IconifyComponent,
  ],
  exports: [
    FooterComponent,
    TopMenuComponent,
    SideMenuComponent,
    admin_headerComponent,
    AdminHeaderComponent,
    CaptchaComponent,
    CreateAdminComponent,
    ResetPasswordComponent,
    UpdateRoleComponent,
    UserHeaderComponent,
    NairaCurrencyPipe,
    RemoveUnderscoresPipe,
    SeparatorDirective,
    NumberToWordsPipe,
    AmountPipe,
    DateonlyPipe,
    DatetimePipe,
    ShortestDatePipe,
    YearOnlyPipe,
    ErrorMessageComponent,
    AppLoaderComponent,
    FileUploadComponent,
    PageSizeComponent,
    MillionFormatterPipe,
    NumberFormatDirective,
    MdaHeaderComponent,
    MdaFooterComponent,
    DateonlyPipe,
    SafeUrlPipePipe,
    NairaCurrencyPipe,
    RemoveUnderscoresPipe,
    RemoveUnderscoreAndSpacePipe,
    SignedPercentagePipe,
    ErrorModalComponent,
    AutoDataLabelDirective,
    BounceLoaderComponent,
    SingleInvoiceActionsDropdownComponent,
    OnlyNumberDirective,
    MatStepperModule,
    NairaAbbreviatePipe,
    SignedPercentagePipe,
    DataIntegrationWrapperComponent,
    AnsaaDataIntegrationComponent,
    IvasDataIntegrationComponent,
    TransportDataIntegrationComponent,
    HaulagetDataIntegrationComponent,
    MotDataIntegrationComponent,
    ArtmaDataIntegrationComponent,
    AnsppbDataIntegrationComponent,
    CultureDataIntegrationComponent,
    DashboardSummaryCardsComponent,
    IconifyComponent,
  ],
})
export class SharedModule {}
